import { useCallback } from 'react';
import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { useModal } from '~/modal/useModal.hook';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import { useBoundaryGroupCheckRemainingGeometryCalls } from '~/store/boundaryGroups/useBoundaryGroupRemainingGeometryCalls';
import { boundaryIsOptimizedTerritoriesTrialSelector } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';

export type OptimizedTerritoriesBlockerFn = (functionToBlock: (() => void)) => () => void;

export const useOptimizedTerritoriesFeatureBlocker = (boundaryGroupId: BoundaryGroupId) => {
  const { openModal } = useModal('WMSUpgradeSubscription');
  const checkIfBoundaryIsOptimizedTerritoriesTrial = useSelector(boundaryIsOptimizedTerritoriesTrialSelector);
  const { checkBoundaryGroupRemainingGeometryCalls } = useBoundaryGroupCheckRemainingGeometryCalls();

  const boundaryIsOptimizedTerritoriesTrial = checkIfBoundaryIsOptimizedTerritoriesTrial(boundaryGroupId);
  const remainingGeometryCalls = checkBoundaryGroupRemainingGeometryCalls(boundaryGroupId);

  const blockWhenOptimizedTerritoriesTrial: OptimizedTerritoriesBlockerFn = useCallback((functionToBlock: () => void) => {
    if (boundaryIsOptimizedTerritoriesTrial) {
      return () => openModal();
    }
    else {
      return () => functionToBlock();
    }
  }, [boundaryIsOptimizedTerritoriesTrial, openModal]);

  return {
    boundaryIsOptimizedTerritoriesTrial,
    blockWhenOptimizedTerritoriesTrial,
    remainingGeometryCalls,
  };
};
